import Repo from "../Utility/Repo";
import { useEffect, useState, useContext } from "react";
import { TokenContext } from "./TokenContext";

function ValidUser() {
  const apiToken = useContext(TokenContext);
  const [isValid, setIsValid] = useState("d-none");

  useEffect(() => {
    getUserAPI();
    return () => {
      setIsValid(""); // This worked for me
    };
  }, []);

  const getUserAPI = () => {
    Repo.getUserInfo(apiToken)
      .then((response) => {
        const user = response.data;

        if (user && user.length) {
          setIsValid("");
        } else {
          setIsValid("d-none");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className={`alert alert-danger ${isValid}`} role="alert">
      <h4 className="alert-heading">Attenzione!</h4>i dati utente risultano
      incompleti. Per proseguire con le iscrizioni ai bandi vai nella sezione{" "}
      <b>Profilo</b> e completa le informazioni mancanti!
    </div>
  );
}

export default ValidUser;
